import PropTypes from 'prop-types';

const perf = PropTypes.arrayOf(PropTypes.shape({
  name: PropTypes.string,
  month: PropTypes.number,
  value: PropTypes.number,
}));

export default perf;
